// App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { ToastContainer } from "react-toastify";

//import Page1 from './pages/Page1';
/* import Page1 from './pages/Page1';
import Page2 from './pages/Page2';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Sidebar from './components/Sidebar';
import RightPanel from './components/Rightpanel'; */

const App = () => {
  return (
    <Router>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
      <Routes>
        {/* Public route: Login */}
        <Route path="/" element={<Login />} />

        {/* Protected route: Dashboard */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard />
           </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
